import { render, staticRenderFns } from "./ViewSubtitle.vue?vue&type=template&id=c07a4ab6&"
import script from "./ViewSubtitle.vue?vue&type=script&lang=js&"
export * from "./ViewSubtitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports